import type { SVGProps } from "react";

export function IconGrayTwo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F8FE" />
      <path
        d="M22.2764 37V35.08L28.2524 29.152C30.0524 27.376 30.6284 26.272 30.6284 25.168C30.6284 23.68 29.5964 22.672 28.0124 22.672C26.4284 22.672 25.4204 23.656 25.0844 25.072H22.3004C22.7804 22.264 24.7004 20.176 28.0844 20.176C31.6124 20.176 33.5324 22.48 33.5324 25.096C33.5324 27.112 32.3564 28.672 30.4844 30.52L26.2844 34.6H33.6524V37H22.2764Z"
        fill="#1C1719"
      />
    </svg>
  );
}
